import React from 'react';
import { useSelector } from 'react-redux';
import { Col } from '@yme/atoms/grid-old';
import { getCommon } from '@yme/common/selectors';
import { Link } from '@yme/components/Link';
import { useWindowSize } from '@yme/hooks/index';
import { FavoriteCardButton } from '@yme/molecules/cards';
import { CardProductPriceBlock } from '@yme/molecules/cards/card-product';
import { ProductLabel } from '@yme/molecules/product-label';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { formatPrice } from '@yme/utils/formatPrice';
import { PartsAccessoriesImage } from './PartsAccessoriesImage';
import { AccessoryNameStyled, ItemAccessoryStyled, PreviewStyled } from './styled';
export function PartsAccessoriesItem(props) {
    const { images, price, discount, name, isRightToLeft = false, daysToShowNew, embargoExternal, url: cardUrl, isLowestPriseExist, onLike, isLiked, } = props;
    const { language } = useSelector(getCommon);
    const { isMobileView } = useWindowSize();
    const discountedValue = formatPrice({
        locale: language,
        currencyName: price?.currencyCode,
        price: discount?.discountedPrice,
    });
    const priceValue = formatPrice({
        locale: language,
        currencyName: price?.currencyCode,
        price: price?.amount,
    });
    return (React.createElement(Col, { xxl: 4, lg: 6, xxlPadding: "32px 0 0 0", lgPadding: "24px 0 0 0", smPadding: "24px 0 0 0", key: name },
        React.createElement(ItemAccessoryStyled, { as: cardUrl ? Link : 'div', to: cardUrl },
            React.createElement(FlexWrapper, { tabIndex: 0, flexDirection: "column" },
                React.createElement(PreviewStyled, { isUrlExist: Boolean(cardUrl) },
                    React.createElement(PartsAccessoriesImage, { images: images, altText: name }),
                    React.createElement(FavoriteCardButton, { onLike: onLike, isLiked: isLiked, fitTo: "top" }),
                    React.createElement(ProductLabel, { isMobileView: isMobileView, isRightToLeft: isRightToLeft, 
                        // Props of necessary labels
                        isSaleLabelNeeded: Boolean(discountedValue), 
                        // for (New label)
                        embargoExternal: embargoExternal, daysToShowNew: daysToShowNew })),
                React.createElement(AccessoryNameStyled, null, name),
                priceValue && (React.createElement(CardProductPriceBlock, { price: priceValue, isRightToLeft: isRightToLeft, discount: discountedValue, isLabelFromVisible: isLowestPriseExist }))))));
}
PartsAccessoriesItem.displayName = 'PartsAccessoriesItem';
